<template>
  <div class="legal-center">
    <!-- 法律援助中心 -->
    <div class="header">
      <div class="title">鹿寨县法律援助中心</div>
      <ul>
        <li><span>业务进展情况：</span>由承办律师联系当事人</li>
        <li>
          <span>上班时间：</span>工作日周一至周五：上午9：00-12：00
          下午：13：00-16：00，法定节假日除外
        </li>
        <li>
          <span>电话：</span><a href="tel:0772-6821141">0772-6821141</a>;<a
            href="tel:12348"
            >12348</a
          >
        </li>
        <li>
          <span>地址：</span>鹿寨县桂园路8号汇一联商务楼二楼法律援助中心窗口
        </li>
      </ul>
    </div>
    <div class="content">
      <ul>
        <li>
          <span class="key">交通指引：</span>
          <span class="val"
            >可乘坐2号、8号公交车至奥运康城站，十字路口往法院边桂园路方向大约300米至汇一联商务楼1-3楼鹿寨县政务服务中心。（鹿寨县桂园路8号汇一联商务楼1-3楼)</span
          >
        </li>
        <li>
          <span class="key">何为法律援助：</span>
          <span class="val"
            >是指政府成立的法律援助中心依法为经济困难的公民和部分刑事案件的当事人提供免费咨询、代理、刑事辩护等法律服务。</span
          >
        </li>
        <li>
          <span class="key">获得法律援助的条件：</span>
          <span class="val"
            >因经济困难无能力承担法律服务费用（经济条件证明）：</span
          >
        </li>
        <li>
          <span class="val"
            >经济困难标准是指申请人及与其共同生活的家庭成员人均收入（如果是家庭成员之间的纠纷，则指申请人的个人收入）符合当地政府规定的经济困难标准；</span
          >
        </li>
        <li>
          <span class="val"
            >申请人经济状况证明由各省规定的有权出证的机关、单位出具。没有相关规定的，则由申请人住所地亦经常居住地的村民委员会、居民委员会或者所在单位出具。</span
          >
        </li>
        <li>
          <span class="key">请求事项属于法律援助范围：</span>
        </li>
        <li>
          <span class="val">依法请求国家赔偿的；</span>
        </li>
        <li>
          <span class="val">请求给予社会保险待遇或者最低生活保障待遇的；</span>
        </li>
        <li>
          <span class="val">请求发给抚恤金、救济金的；</span>
        </li>
        <li>
          <span class="val">请求发给赡养费、抚养费、扶养费的；</span>
        </li>
        <li>
          <span class="val">请求支付劳动报酬的；</span>
        </li>
        <li>
          <span class="val">主张见义勇为产生的民事权益的；</span>
        </li>
        <li>
          <span class="val">请求工伤赔偿的（限农民工）；</span>
        </li>
        <li>
          <span class="val"
            >国家和本省规定的其他事项 哪些人不需要申请就可以获得法律援助：</span
          >
        </li>
        <li>
          <span class="val"
            >在刑事案件中，下列犯罪嫌疑人、被告人没有委托辩护人的，人民法院、人民检察院合公安局机关应当通知法律援助中心指派律师为其辩护，其无需申请就可以直接获得法律援助：</span
          >
        </li>
        <li>
          <span class="val">聋、哑、盲 或者未成年人；</span>
        </li>
        <li>
          <span class="val"
            >尚未完全丧失辩认或者控制自己行为能力的精神病人；</span
          >
        </li>
        <li>
          <span class="val">可能被判无期徒刑、死刑的。</span>
        </li>
        <li>
          <span class="val"
            >另外：人民法院审理强制医疗案件时，如果被申请人或者被告人没有委托诉讼代理人的，人民法院也会通知法律援助中心指派律师为其提供法律帮助。</span
          >
        </li>
        <li>
          <span class="val"
            >另外：人民法院审理强制医疗案件时，如果被申请人或者被告人没有委托诉讼代理人的，人民法院也会通知法律援助中心指派律师为其提供法律帮助。</span
          >
        </li>
        <li>
          <span class="key">哪些人在申请法律援助时不需要经济状况证明：</span>
        </li>
        <li>
          <span class="val"
            >申请人持下列证件或证明材料之一的，不需要经济状况证明：</span
          >
        </li>
        <li>
          <span class="val"
            >城市居民最低生活保障证或者农村居民最低生活保障证；</span
          >
        </li>
        <li>
          <span class="val">农村特困户救助证；</span>
        </li>
        <li>
          <span class="val">农村“五保”供养证；</span>
        </li>
        <li>
          <span class="val">人民法院给予申请人司法救助的决定；</span>
        </li>
        <li>
          <span class="val"
            >在社会福利机构中由政府出资供养或者慈善机构出资供养的证明材料</span
          >
        </li>
        <li>
          <span class="val"
            >残疾证及申请人住所地或者经常居住地的村民居委会、居民委员会出具的无固定生活来源的证明材料；</span
          >
        </li>
        <li>
          <span class="val"
            >残疾证及申请人住所地或者经常居住地的村民居委会、居民委员会出具的无固定生活来源的证明材料；</span
          >
        </li>
        <li>
          <span class="val">依靠政府或者单位给抚恤金生活的证明材料；</span>
        </li>
        <li>
          <span class="val"
            >因自然灾害等原因导致生活出现短暂困难，正在接受政府临时救济的证明材料。</span
          >
        </li>
        <li>
          <span class="val"
            >农民工因请求支付劳动报酬或者工伤赔偿申请法律救助的，不需要经济状况证明。</span
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.legal-center {
  margin-top: 62px;
  .header {
    padding: 15px 15px 20px;
    background-color: rgba(122, 191, 255, 0.14);
    border-radius: 4px;
    .title {
      font-size: 16px;
      color: #333333;
      font-weight: 600;
    }
    ul {
      li {
        margin-top: 10px;
        line-height: 17px;
        font-size: 12px;
        color: #333;
        span {
          font-weight: 600;
        }
        a {
          color: #0882f3;
        }
      }
    }
  }
  .content {
    margin-top: 15px;
    background-color: #fff;
    ul {
      li {
        .key {
          font-weight: 600;
          font-size: 14px;
          color: #333;
        }
        .val {
          font-size: 14px;
          color: #333;
        }
      }
      li ~ li {
        margin-top: 10px;
      }
    }
  }
}
</style>
